import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import { Button, Input } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import {
  useAddUserMutation,
  useGetAllDispatchersQuery,
  useUserUpdateMutation,
} from "../../Data/services/userApi";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import BeatLoader from "react-spinners/BeatLoader";
import { Controller, useForm } from "react-hook-form";
import SelectFieldComponent from "../CustomComponents/SelectFieldComponent";
import _ from "lodash";

const CreateEditUserModal = ({ handleCloseModal, userData, refetch }) => {
  console.log(userData);
  const [sending, setSending] = useState(false);
  const [selectedRole, setSelectedRole] = useState("");
  const [selectedDispatcher, setSelectedDispatcher] = useState("");
  const [dispatcherSlug, setDispatcherSlug] = useState("");
  const { handleSubmit, control, setValue } = useForm({});

  const { data, isSuccess, isLoading, isFetching } = useGetAllDispatchersQuery(
    {
      search: "",
      limit: 100,
      page: 1,
    },
    { refetchOnMountOrArgChange: true }
  );

  const roleList = [
    { label: "OFFICER", value: "OFFICER" },
    { label: "DISPATCHER", value: "DISPATCHER" },
  ];

  const dispatchersData =
    data?.data?.length > 0
      ? data?.data
          ?.filter((x) => !x?.is_blocked)
          ?.map((x) => {
            return { label: x?.name, value: x?.slug };
          })
      : [];

  useEffect(() => {
    if (userData) {
      setSelectedRole(userData.user_type || "OFFICER");
      setValue("role", userData.user_type);
      setDispatcherSlug(userData.dispatcher_slug || "");
      setSelectedDispatcher(userData?.dispatcher?.name || userData?.name);
      setValue("name", userData.name);
      setValue("email", userData.email);
      setValue("badge_no", userData.badge_no);
    }
  }, [userData]);

  useEffect(() => {
    if (selectedRole === "DISPATCHER") {
      setSelectedDispatcher("");
    }
  }, [selectedRole]);

  const [addUser, { isLoading: adding }] = useAddUserMutation();
  const [userUpdate, { isLoading: updating }] = useUserUpdateMutation();

  const onSubmit = async (record) => {
    setSending(true);
    try {
      const badgeno = data?.data?.find((x) => x?.slug === dispatcherSlug);
      console.log(badgeno);
      const payload = {
        name: record.name,
        email: record.email,
        role: record.role,
        badge_no:
        record.role === "OFFICER" ? badgeno?.badge_no : record.badge_no,
        dispatcher_slug: record.role === "OFFICER" ? dispatcherSlug : null,
      };

      let response;
      if (userData) {
        response = await userUpdate({ ...payload, id: userData.id });
      } else {
        response = await addUser(payload);
      }

      if (response.data.code === 200) {
        refetch();
        setSending(false);
        SuccessToast(response?.data?.message);
        if (!userData) {
          setTimeout(() => SuccessToast("Credentials send to the given mail check your mail now", 5000), 1000)
        }
        handleCloseModal();
      }
    } catch (error) {
      setSending(false);
      Toast(error?.response?.data?.message || error.message, "error");
      handleCloseModal();
    } finally {
      refetch();
    }
  };

  return (
    <div>
      <ModalContainer handleClose={handleCloseModal}>
        <div className={cssStyles.modalContainer} style={{ minWidth: "40%" }}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-semibold m-0 black-text">
              {userData ? "Edit User" : "Create User"}
            </p>
            <span className="bg-white bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleCloseModal}
                style={{ cursor: "pointer", color: "black" }}
              />
            </span>
          </div>
          <div className="w-100">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Row>
                <Col md={12}>
                  <p className="m-0 black-text">Role</p>
                  <Controller
                    control={control}
                    name="role"
                    rules={{}}
                    defaultValue={selectedRole}
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <SelectFieldComponent
                        firstOption={
                          _.isEmpty(selectedRole) ? "Select Role" : selectedRole
                        }
                        optionsList={roleList}
                        onSelectChange={(e) => {
                          onChange(e);
                          setSelectedRole(e);
                        }}
                      />
                    )}
                  />
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <Controller
                    control={control}
                    name="name"
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <Input
                        type="text"
                        value={value}
                        onChange={onChange}
                        placeholder="Enter Name"
                        defaultValue={userData ? userData.name : ""}
                      />
                    )}
                  />
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <Controller
                    control={control}
                    name="email"
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <Input
                        type="email"
                        value={value}
                        onChange={onChange}
                        placeholder="Enter Email"
                        defaultValue={userData ? userData.email : ""}
                      />
                    )}
                  />
                </Col>
              </Row>

              {/* Dispatcher Field - Only for OFFICER */}
              {selectedRole === "OFFICER" && (
                <Row>
                  <Col md={12}>
                    <Controller
                      control={control}
                      name="dispatcher_slug"
                      rules={{}}
                      defaultValue={selectedDispatcher}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <SelectFieldComponent
                          firstOption={
                            _.isEmpty(selectedDispatcher)
                              ? "Select Dispatcher"
                              : selectedDispatcher
                          }
                          optionsList={dispatchersData}
                          onSelectChange={(e) => {
                            onChange(e);
                            setDispatcherSlug(e);
                          }}
                        />
                      )}
                    />
                  </Col>
                </Row>
              )}

              {/* Badge Number Field - Only for DISPATCHER */}
              {selectedRole === "DISPATCHER" && (
                <Row>
                  <Col md={12}>
                    <Controller
                      control={control}
                      name="badge_no"
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Input
                          type="number"
                          value={value}
                          onChange={onChange}
                          placeholder="Enter Badge Number"
                          defaultValue={userData ? userData.badge_no : ""}
                        />
                      )}
                    />
                  </Col>
                </Row>
              )}

              {/* Submit Button */}
              <Row>
                <Col md={12}>
                  <Button
                    classes={`${cssStyles.cardBtn} mt-4`}
                    text={
                      sending ? (
                        <BeatLoader size={10} />
                      ) : userData ? (
                        "Update User"
                      ) : (
                        "Save User"
                      )
                    }
                    onClick={handleSubmit(onSubmit)}
                    disabled={sending}
                  />
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default CreateEditUserModal;
